import React from 'react';

	
//function ResultPrintingClass({resultClass}) {
class StartListClass extends React.PureComponent { 
	constructor(props) {
	    super(props);
	}
	


	render() {
		const competitionClass = this.props.competitionClass;

		let c = 0;
		const hSize = this.props.headingSize || 25;
		const lSize = this.props.lineSize || 12;

		return (
			<div className="printstart">
			<h1 style={{fontSize: `${hSize}px`}}>{competitionClass.name}</h1>
			<table className="startdisplaytable" >
				<tbody>
					{competitionClass.runners.map(runner => ( runner.status === 'Borttagen' || !this.props.showNonPaid && (runner.status === 'Registrerad') ? '' :
						<tr className={"startdisplayrow" + (runner.status === 'Registrerad' ? ' notpaid' : '')}
							key={runner.id + c++} style={{fontSize: `${lSize}px`}}>
							<td className="bib">{runner.bib || ''}</td>
							<td className="startRunnerName">{runner.firstName + ' ' + runner.lastName}</td>
							<td>{runner.club}</td>
							<td>{runner.team ? runner.team.name : ''}</td>
							<td>{this.props.showNonPaid ? (runner.status === 'Anmäld' ? 'ja' : 'nej') : ''}</td>
						</tr>))}
				</tbody>

			</table>
			</div>
		);
}
}

export default StartListClass;
